<style lang="scss" scoped>
    .vue-notification {
        display: flex;
        min-height: 50px;
        color: #fff;
        padding: 8px 15px;
        margin: 5px 5px 0 0;
        align-items: center;

        .notification-icon {
            min-width: 35px;
            max-width: 35px;
            display: flex;
            font-size: 25px;
        }
    }
</style>

<template>
    <notifications>
        <template slot="body" slot-scope="props">
            <div @click="props.close">
                <router-link v-if="props.item.data.link" tag="div" :to="props.item.data.link" :class="`vue-notification ${props.item.type}`">
                    <div class="notification-icon">
                        <div :class="`${props.item.data.icon}`"></div>
                    </div>
                    <div class="">
                        <div class="notification-title">{{props.item.title}}</div>
                        <div class="notification-content" v-html="props.item.text"></div>
                    </div>
                </router-link>
                <div v-else :class="`vue-notification ${props.item.type}`">
                    <div class="notification-icon">
                        <div :class="`${props.item.data.icon}`"></div>
                    </div>
                    <div class="">
                        <div class="notification-title">{{props.item.title}}</div>
                        <div class="notification-content" v-html="props.item.text"></div>
                    </div>
                </div>
            </div>
        </template>
    </notifications>
</template>

<script>
    export default {
        name: 'VueNotification'
    }
</script>



// WEBPACK FOOTER //
// src/components/helpers/VueNotifications.vue